import React from "react";
import { NavLink } from "react-router-dom";
import "./NavNotification.scss";
import { ImCancelCircle } from "react-icons/im";
import { FaRegCheckCircle } from "react-icons/fa";

const NavNotification = ({ setShowNotification, notificationLink }) => {
  console.log("notificationLink", notificationLink);
  const goingTo = notificationLink.substring(1);
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-content">
          <article className="notification">
            <div className="notification-message">
              If you continue, all changes to your label will be lost!
              <br />
              Do you wish to navigate to the{" "}
              {notificationLink === "/"
                ? "Home"
                : capitalizeFirstLetter(goingTo)}{" "}
              page?
              <div className="notification-confirmation">
                <NavLink
                  to={notificationLink}
                  onClick={() => setShowNotification(false)}
                >
                  <span className="check-icon">Go to {notificationLink === "/" ? "Home"  : capitalizeFirstLetter(goingTo)}</span>
                </NavLink>
                <span className="cancel-icon" onClick={() => setShowNotification(false)}>Stay Here</span>
              </div>
            </div>
          </article>
        </div>
        <button
          className="modal-close is-large"
          aria-label="close"
          onClick={() => setShowNotification(false)}
        ></button>
      </div>
  );
};

export default NavNotification;
